import ApiService from "@/core/services/api.service";

// action types
export const LIST_ROLES = "list_roles";
export const ADD_ROLE = "add_role";
export const EDIT_ROLE = "edit_role";
export const DELETE_ROLE = "delete_role";

// mutation types
export const SET_ERROR = "setErrorRoles";

const actions = {
    [LIST_ROLES](context) {
        return new Promise(resolve => {
            ApiService.post("show_roles", {})
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [ADD_ROLE](context, params) {
        return new Promise(resolve => {
            ApiService.post("add_role", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [EDIT_ROLE](context, params) {
        return new Promise(resolve => {
            ApiService.post("edit_role", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
    [DELETE_ROLE](context, params) {
        return new Promise(resolve => {
            ApiService.post("delete_role", params)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
};

export default {
    actions
};
